function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from 'prop-types';
export var registerEvents = function registerEvents(events, props, instance) {
  var eventsAvailable = Object.keys(events);
  var listeners = Object.keys(props).filter(function (key) {
    return eventsAvailable.indexOf(key) !== -1;
  }).map(function (name) {
    return instance.addListener(events[name], function (event) {
      props[name]({
        event: event,
        marker: instance
      });
    });
  });
  return function () {
    listeners.forEach(function (listener) {
      return listener.remove();
    });
  };
};
export var createListenersPropTypes = function createListenersPropTypes(eventTypes) {
  return Object.keys(eventTypes).reduce(function (acc, name) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, PropTypes.func));
  }, {});
};
export var createFilterProps = function createFilterProps(excludes) {
  return function (props) {
    return Object.keys(props).filter(function (name) {
      return excludes.indexOf(name) === -1;
    }).reduce(function (acc, name) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, props[name]));
    }, {});
  };
};